import { useState } from 'react';
import OnboardingLayout from '../pages/onboarding/OnboardingLayout';
import { WithAccountsSelectionDialog } from './WithAccountsSelectionDialog';
import { AccountSelectionCreateAccount } from './AccountSelectionCreateAccount';

export const AccountSelectionPage = () => {
  const [isRenderPopover, setIsRenderPopover] = useState(true);

  if (isRenderPopover) {
    return (
      <OnboardingLayout withLogout={true}>
        <WithAccountsSelectionDialog
          children={<></>}
          isBlockingAccountSelection
          onCreateNewAccountClick={() => setIsRenderPopover(false)}
        />
      </OnboardingLayout>
    );
  }

  return <AccountSelectionCreateAccount onGoBack={() => setIsRenderPopover(true)} />;
};
